import React, { useEffect, useRef, useState } from "react";
import Loading from "../loadingScreen/Loading";
import { isEmpty } from "../../../Utils/utils";

const PaymentNotify = () => {
    const formRef = useRef(null);
    const [acsUrl, setAcsUrl] = useState("");
    const [formFields, setFormFields] = useState({});

    useEffect(() => {
        try {
            const params = new URLSearchParams(window.location.search);
            const encodedData = params.get("challengeData");
            const sanitized = encodedData.replace(/-/g, '+').replace(/_/g, '/');

            const decoded = atob(sanitized);

            const parsedData = JSON.parse(decoded);
            if (!parsedData?.acsUrl) {
                const raw = sessionStorage.getItem("s_d");
                const sessionData = JSON.parse(raw);
                if (sessionData) {
                    if (sessionData.callerType == "PAYMENT_LINK") {
                        window.location.replace(`/${sessionData.token}`)
                    } else {
                        window.location.replace(`/?token=${sessionData.token}`)

                    }
                }
            }
            if (parsedData?.type?.toLowerCase() == "get") {
                window.location.replace(parsedData.acsUrl)
                return
            }
            setAcsUrl(parsedData.acsUrl);
            setFormFields(parsedData.challengeData);
        } catch (err) {
            console.error("Failed to process challengeData", err);
        }
    }, []);

    // Submit ONLY after JSX inputs are rendered
    useEffect(() => {
        if (acsUrl && !isEmpty(formFields) && Object.keys(formFields).length && formRef.current) {
            formRef.current.submit();
        }
    }, [acsUrl, formFields]);

    return (
        <div className="loading-overlay">
            <Loading
                text="Redirecting you to your bank for verification..."
                subText=""
            />

            {!isEmpty(formFields) && <form ref={formRef} method="POST" action={acsUrl}>
                {Object.entries(formFields).map(([name, value]) => (
                    <input key={name} type="hidden" name={name} value={value} />
                ))}
            </form>}
        </div>
    );
};

export default PaymentNotify;
